<template>
  <div class="header">
    <van-popup v-model="showMenu" position="right">
      <div class="menu-wrap">
        <div class="menu-head">
          <div @click="goback()">
            <span class="icon icon-arrow-left"></span><span>返回</span>
          </div>
        </div>
        <div class="row row-wrap" v-if="list">
          <a @click="goTo(item)" class="col-6" v-for="(item,index) in list"  v-if="!item.show" :key="index">
            <v-image :src="`/images/icons/menu/menu_0${index+1}.png`"/>
            <span>{{item.title}}</span>
          </a>
        </div>
      </div>
    </van-popup>
    <div class="m-icon-menu" ref="menu" @click="setMenu($event)" v-drag>
      <i class="icon icon-menu"></i>
    </div>
  </div>
</template>
<script>
import { Popup, Toast } from 'vant'
import { Location } from '@/assets/scripts/helper'
import vDrag from '@/assets/scripts/directives/drag'

import { mapState } from 'vuex'
import Vue from 'vue'

Vue.use(Popup).use(Toast)
export default {
  data () {
    return {
      showMenu: false
    }
  },
  computed: {
    centerData () {
      return this.$store.state.center.sysCenter.centerConfigMenu
    },
    list () {
      let arr = []
      if (this.sid !== '00-0' && this.centerData) {
        arr = [
          {href: 'main', title: '微官网'},
          {href: 'entrance', title: '体检预约'},
          {href: 'specialDisease', title: '专病专栏', show: !this.centerData.includes('columnFlag')},
          {href: 'order', title: '我的订单'},
          {href: 'reportList', title: '体检报告', show: this.infoData.receiveOnline === 0},
          {href: 'card', title: '健康评估', show: !this.centerData.includes('healthFlag')},
          {href: 'onlineCommunicationList', title: '在线沟通', show: !this.centerData.includes('onlineFlag')},
          {href: 'personage', title: '个人中心'}
        ]
      } else {
        arr = [
          {href: 'main', title: '微官网'},
          {href: 'entrance', title: '体检预约'},
          {href: 'specialDisease', title: '专病专栏'},
          {href: 'order', title: '我的订单'},
          {href: 'reportList', title: '体检报告'},
          {href: 'card', title: '健康评估'},
          {href: 'onlineCommunicationList', title: '在线沟通'},
          {href: 'personage', title: '个人中心'}
        ]
      }
      return arr
    },
    infoData () {
      return this.$store.state.center.sysCenter || {}
    },
    ...mapState({
      sid: state => state.sid
    })
  },
  props: {},
  watch: {
  },
  methods: {
    setMenu (e) {
      this.showMenu = true
    },
    goback () {
      this.$router.go(-1)
      this.showMenu = false
    },
    goTo (item) {
      if (item.state === 'old') {
        Location(item.href)
      } else if (item.state === 'unfinished') {
        Toast.fail('正在开发中')
      } else {
        if (item.href === 'main' && this.sid !== '00-0') {
          this.$router.replace({name: 'mec', params: {id: this.sid}})
        } else {
          this.$router.replace({name: item.href})
        }
      }
      this.showMenu = false
    }
  }

}
</script>

<style lang="scss" scoped>
  @import "@/assets/style/variables.scss";

  .header {
    img {
      display: block;
      height: 100%;
      margin: 0 auto;
    }
  }

  .m-icon-menu {
    color: $orange;
    position: fixed;
    font-size: 18px;
    background: $light;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid $orange;
    text-align: center;
    line-height: 37px;
  }

  .van-popup /deep/ {
    height: 100%;
  }

  .menu-wrap {
    /*position: fixed;*/
    /*right: 0;*/
    /*top: 0;*/
    /*bottom: 0;*/
    width: 220px;
    background: $light;
    z-index: 10001;
    padding-bottom: 20px;
    overflow-y: auto;
    .menu-head {
      div {
        display: inline-block;
        padding: 0 10px;
      }
      border-bottom: .5px solid #999;
      height: $bar-height;
      line-height: $bar-height;
      padding-left: 10px;
    }
    .row {
      .col-6 {
        padding: 20px 0;
        position: relative;
        &:active {
          opacity: 0.8;
        }
      }
      span {
        padding-top: 15px;
        display: block;
        text-align: center;
      }
      img {
        width: 52px;
        height: 52px;
      }
    }
  }
</style>
